// @flow

import ApiError from '../../entities/ApiError';
import ApiErrorUtils from '../ApiErrorUtils';
import I18n from '../../i18n/I18n';

export default class UserApiErrors {

  static login(apiError: ApiError): string {
    const errors = {
      '100': I18n.tr('api.error.user.login.100'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:login');
  };

  static postUser(apiError: ApiError): string {
    // 100 - email already used
    // 104 - fid already used
    // 101 - incomplete profile
    // 103 - can’t create bank account
    // 106 - can’t create bank wallet
    // 105 - Unknow sponsorship
    // 107 - Phone already used

    const errors = {
      '100': I18n.tr('api.error.user.post.100'),
      '104': I18n.tr('api.error.user.post.104'),
      '101': I18n.tr('api.error.user.post.101'),
      '103': I18n.tr('api.error.user.post.103'),
      '106': I18n.tr('api.error.user.post.106'),
      '105': I18n.tr('api.error.user.post.105'),
      '107': I18n.tr('api.error.user.post.107'),
      '122': I18n.tr('api.error.user.post.122'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:postUser');
  };

  static putUser(apiError: ApiError): string {
    // 120 - missing right to get user
    // 100 - email already used by another user
    // 101 - invalid email format
    // 117 - invalid password verification (wrong old password or password recovery)
    // 104 - invalid international phone number format
    // 103 - phone number already used by another user

    const errors = {
      '120': I18n.tr('api.error.user.put.120'),
      '100': I18n.tr('api.error.user.put.100'),
      '101': I18n.tr('api.error.user.put.101'),
      '117': I18n.tr('api.error.user.put.117'),
      '104': I18n.tr('api.error.user.put.104'),
      '103': I18n.tr('api.error.user.put.103'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:putUser');
  };

  static postCreditCard(apiError: ApiError): string {

    // 101 - User not found
    // 102 - User mismatch
    // 140 - Card registration exception
    // 141 - User card registration and User mismatch
    // 142 - Card registration status not VALIDATED
    // 143 - Card pre-authorization status not SUCCEEDED

    const errors = {
      '140': I18n.tr('api.error.user.credit_card.post.140'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:postCreditCard');
  };

  static getAddresses(apiError: ApiError): string {
    const errors = {

    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:getAddresses');
  }

  static postAddress(apiError: ApiError): string {

    // 101 - User mismatch
    // 102 - Not allowed
    // 103 - User address not found
    // 104 - Missing address body
    // 105 - Address cannot be geocoded

    const errors = {
      '101': I18n.tr('api.error.address.post.101'),
      '102': I18n.tr('api.error.address.post.102'),
      '103': I18n.tr('api.error.address.post.103'),
      '104': I18n.tr('api.error.address.post.104'),
      '105': I18n.tr('api.error.address.post.105'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:postAddress');
  }

  static deleteCreditCard(apiError: ApiError): string {
    const errors = {
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:deleteCreditCard');
  }

  static putAddress(apiError: ApiError): string {

    // 101 - User mismatch
    // 102 - Not allowed
    // 103 - User address not found
    // 104 - Missing address body
    // 105 - Address cannot be geocoded

    const errors = {
      '101': I18n.tr('api.error.address.put.101'),
      '102': I18n.tr('api.error.address.put.102'),
      '103': I18n.tr('api.error.address.put.103'),
      '104': I18n.tr('api.error.address.put.104'),
      '105': I18n.tr('api.error.address.put.105'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:putAddress');
  }

  static deleteAddress(apiError: ApiError): string {
    const errors = {

    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'UserApiErrors:deleteAddress');
  }
}
